import styled from 'styled-components';

export const OfferTypeList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CheckboxGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const LocationWrapper = styled.div`
  padding: 6px 0;
`;

export const RangeRow = styled.div`
  display: flex;
  gap: 12px;
  padding: 12px 0 6px;
  max-width: 560px;
`;

export const PriceRangeStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 6px 0;
`;
